// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uwNyXX {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
}

.BNzBPl {
  font-family: var(--font-family-base);
}

/* Main Content */
.Yhb57M {
  display: flex;
  background-color: transparent;
  flex-direction: column;
}

.A3qRV7 {
  background-color: transparent;
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-card);
}

/* Stepper Header */
.U7Z1kQ {
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2);
  border-bottom: 1px solid var(--surface-neutral-subtle);
}

.XiDENF {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.CezjAm {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-3);
  height: var(--spacing-3);
  background-color: var(--surface-primary-medium);
  border-radius: var(--spacing-1-5);
}

.uMQU25 {
  color: var(--text-neutral-white);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
}

.dcV4DD {
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-lg);
  line-height: var(--type-title-md-line-height);
  margin: 0;
}

/* Card Content */
.xvUReK {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  height: 100%;
}

.TKUjoz {
  position: absolute;
  top: var(--spacing-3);
  right: 0;
  z-index: 1000;
  width: 320px;
  min-width: initial;
  transform: initial;
}

.pgXPXE {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  padding: var(--spacing-1) var(--spacing-1-5);
  background-color: var(--info-card-background);
  border: 1px solid var(--status-info);
  border-radius: var(--radius-s);
  margin-bottom: 0;
  position: relative;
}

.NfkG1s {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-2-5);
  height: var(--spacing-2-5);
  color: var(--status-info);
}

.hvl_kk {
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  flex: 1;
}

.RE5xLJ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-2-5);
  height: var(--spacing-2-5);
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--text-neutral-stronger);
  margin-left: auto;
}

.RE5xLJ:hover {
  color: var(--text-neutral-dark);
}

/* Form Sections */
.uSA7RN {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

/* Step 2 Styles */
.i8LGmH {
  display: flex;
  gap: var(--spacing-2);
  align-items: center;
  margin-top: var(--spacing-1);
}

.dJTfCF {
  background-color: var(--surface-primary-medium);
  color: var(--text-neutral-white);
  border: none;
  border-radius: var(--radius-s);
  padding: var(--spacing-1) var(--spacing-2);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-sm);
  cursor: pointer;
  white-space: nowrap;
}

.dJTfCF:hover {
  background-color: var(--surface-primary-dark);
}

.eNFS0H {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-2);
}

.Nv4iaF {
  max-width: 300px;
}

.fRef7J {
  min-height: 40px;
  padding-left: 12px;
  background-color: var(--surface-neutral-white);
  border: 1px solid var(--surface-neutral-subtle);
  border-radius: var(--radius-s);
}

.nKiDuH {
  margin-bottom: var(--spacing-2);
  padding-bottom: var(--spacing-1);
  border-bottom: 1px solid var(--surface-neutral-subtle);
}

.IPHEgW {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  cursor: pointer;
}

.rdlDG1 {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.HlfkXC {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
}

.OQfj9J {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.fjJURL {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-2);
  border: 1px solid var(--surface-neutral-subtle);
  border-radius: var(--radius-s);
  background-color: var(--surface-neutral-white);
}

.fjJURL.cpRiq9 {
  opacity: 0.6;
  background-color: var(--surface-neutral-subtle);
}

.OwkGZZ {
  flex: 1;
}

.nHdU4I {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
  margin-left: var(--spacing-1);
}

.jIbx4b {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
}

.EpS6Ym {
  display: flex;
  gap: var(--spacing-2);
}

.xh1BMg {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-stronger);
}

.vFnLv2 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-stronger);
}

.izShMZ {
  min-width: 120px;
}

.B6dDRQ {
  min-height: 40px;
  padding-left: 12px;
  background-color: var(--surface-neutral-white);
  border: 1px solid var(--surface-neutral-subtle);
  border-radius: var(--radius-s);
}

/* Sidebar states */
.kNEqpv {
  color: var(--status-success) !important;
}

.kNEqpv .ULMzdl {
  background-color: var(--status-success) !important;
}

/* Modal Styles */
.zCLgVZ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.JYkHTG {
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-m);
  padding: var(--spacing-4);
  max-width: 480px;
  width: 90%;
  box-shadow: var(--shadow-modal);
}

.GGMrZF {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  margin-bottom: var(--spacing-3);
}

.I60wgL {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  color: var(--text-neutral-dark);
  margin: 0;
}

.GNirKT {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-stronger);
  line-height: var(--line-height-180);
  margin-bottom: var(--spacing-4);
}

.UuF4U5 {
  display: flex;
  gap: var(--spacing-2);
  justify-content: flex-end;
}

.BekYjs {
  padding: var(--spacing-1-5) var(--spacing-3);
  border-radius: var(--radius-s);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-md);
  cursor: pointer;
  border: 1px solid var(--surface-neutral-subtle);
  background-color: var(--surface-neutral-white);
  color: var(--text-neutral-dark);
}

.BekYjs:hover {
  background-color: var(--surface-neutral-subtle);
}

.BekYjs.rS_uGb {
  background-color: var(--surface-primary-medium);
  color: var(--text-neutral-white);
  border-color: var(--surface-primary-medium);
}

.BekYjs.rS_uGb:hover {
  background-color: var(--surface-primary-dark);
  border-color: var(--surface-primary-dark);
}

.Zp90lv {
  color: var(--status-success);
  width: var(--spacing-3);
  height: var(--spacing-3);
}

.E06q7J {
  color: var(--status-error);
  width: var(--spacing-3);
  height: var(--spacing-3);
}

/* Summary Sidebar Styles */
.uz5_kh {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  width: 100%;
}

.KPxBAP {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: var(--spacing-0-5);
  border-radius: var(--radius-s);
  color: var(--text-neutral-stronger);
  display: flex;
  align-items: center;
  justify-content: center;
}

.KPxBAP:hover {
  background-color: var(--surface-neutral-subtle);
  color: var(--text-neutral-dark);
}

.NVclKj {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
  width: 100%;
}

.epNcKW {
  display: flex;
  align-items: center;
  width: 100%;
}

.AcjaMv {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--type-label-sm-regular-font-weight, 400);
  font-size: var(--type-label-sm-font-size, 12px);
  line-height: 1.424;
  width: 50%;
  color: var(--text-neutral-stronger, #666666);
}

.Rj0pdC {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--type-label-sm-font-weight, 600);
  font-size: var(--type-label-sm-font-size, 12px);
  line-height: 1.424;
  width: 50%;
  color: var(--text-neutral-dark, #1f1f1f);
}

.cWqMCB {
  margin-top: var(--spacing-2);
  display: flex;
  flex-direction: column;
}

.rA61FX {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
  width: 100%;
}

.y3yMgp {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-stronger);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.ZGix0J {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-dark);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.wWzxkY {
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--type-title-md-line-height);
  margin: 0;
}

.wZ6anQ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.P9eB6a {
  display: flex;
  flex-direction: column;
}

.uRBsN9 {
  display: flex;
  gap: var(--spacing-3);
  flex-direction: row;
}

.u_lRu9 {
  margin-top: var(--spacing-1-5);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.JlFTPU {
  min-height: 48px;
  padding-left: 12px;
  background-color: var(--info-card-background);
  border: 1px solid #cccccc;
  border-radius: var(--radius-s);
}

.gchZsx {
  color: var(--text-neutral-stronger);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-200);
}

.k0X1dy {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
  margin-top: var(--spacing-1);
}

.HT7UrA {
  min-height: 48px;
  padding-left: 12px;
  background-color: var(--info-card-background);
  border: 1px solid #cccccc;
  border-radius: var(--radius-s);
}

._cd7hG {
  background-color: transparent !important;
  width: fit-content;
  padding: 12px 0;
}

/* Switch Styles */
.K8nNg7 {
  position: relative;
  display: inline-block;
}

.YXiqgo {
  opacity: 0;
  width: 0;
  height: 0;
}

.JX4Fez {
  position: relative;
  display: inline-block;
  width: 40px;
  height: var(--spacing-3);
  cursor: pointer;
}

.J4MBi7 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--surface-neutral-silver);
  border-radius: var(--spacing-3);
  transition: var(--transition-color);
}

.J4MBi7:before {
  position: absolute;
  content: '';
  height: var(--spacing-2);
  width: var(--spacing-2);
  left: var(--spacing-0-5);
  bottom: var(--spacing-0-5);
  background-color: var(--surface-neutral-white);
  border-radius: 50%;
  transition: var(--transition-transform);
}

.YXiqgo:checked + .JX4Fez .J4MBi7 {
  background-color: var(--surface-primary-medium);
}

.YXiqgo:checked + .JX4Fez .J4MBi7:before {
  transform: translateX(var(--spacing-2));
}

/* Card Actions */
.Gr7p9N {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--spacing-1-5);
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
}

.PWAtXe {
  width: 100px;
  height: 40px;
  padding: var(--spacing-1) var(--spacing-1-5);
  border-radius: var(--radius-s);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--type-label-md-line-height);
  cursor: pointer;
  transition: var(--transition-all);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid transparent;
}

.PWAtXe:first-child {
  background-color: var(--surface-neutral-white);
  color: var(--surface-primary-medium);
  border-color: var(--surface-primary-medium);
}

.PWAtXe:last-child {
  background-color: var(--surface-primary-medium);
  color: var(--surface-neutral-white);
  border-color: var(--surface-primary-medium);
}

/* Sidebar */
.dubc8h {
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-card);
  height: fit-content;
}

.eS5SDx {
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2);
  border-bottom: 1px solid var(--surface-neutral-subtle);
}

.LB7YLw {
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-lg);
  line-height: var(--type-title-md-line-height);
  margin: 0;
}

.zEdnML {
  height: 1px;
  background-color: var(--stroke-neutral-soft);
  margin: 0 10px;
}

.BCdX2O {
  padding: var(--spacing-3);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.h6oiYQ {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.ULMzdl {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-3);
  height: var(--spacing-3);
  background-color: var(--surface-primary-medium);
  border-radius: var(--spacing-1-5);
}

.ULMzdl.bTBCdA {
  background-color: transparent;
  border: 1px solid var(--text-neutral-strong);
}

.rRd0zY {
  color: var(--text-neutral-white);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
}

.ULMzdl.bTBCdA .rRd0zY {
  color: var(--text-neutral-strong);
}

.SokGBa {
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-lg);
  line-height: var(--type-title-md-line-height);
}

.SokGBa.bTBCdA {
  color: var(--text-neutral-strong);
}

.z0jSrA {
  height: 1px;
  background-color: var(--surface-neutral-subtle);
  width: 100%;
}

.Rfb7ma {
  width: 14px;
  height: 14px;
  color: var(--text-neutral-white);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/ParametersPage/ParametersPage.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,2DAA2D;EAC3D,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,6CAA6C;EAC7C,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;EAC5C,6CAA6C;EAC7C,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,gCAAgC;EAChC,YAAY;EACZ,8BAA8B;EAC9B,0CAA0C;EAC1C,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,+CAA+C;EAC/C,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,8CAA8C;EAC9C,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;EAC9B,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,eAAe;EACf,+CAA+C;EAC/C,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,8BAA8B;EAC9B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,0DAA0D;EAC1D,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,mCAAmC;EACnC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,6CAA6C;EAC7C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+CAA+C;EAC/C,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,8CAA8C;EAC9C,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;AACzC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4CAA4C;EAC5C,8BAA8B;EAC9B,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,6CAA6C;EAC7C,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,8CAA8C;EAC9C,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;EAC/C,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA,YAAY;AACZ;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;EAC3D,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,6CAA6C;EAC7C,SAAS;AACX;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC","sourcesContent":[".pageWrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  height: 100%;\n  min-height: 0;\n}\n\n.contentLayoutParameters {\n  font-family: var(--font-family-base);\n}\n\n/* Main Content */\n.mainContent {\n  display: flex;\n  background-color: transparent;\n  flex-direction: column;\n}\n\n.mainCard {\n  background-color: transparent;\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-card);\n}\n\n/* Stepper Header */\n.stepperHeader {\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2);\n  border-bottom: 1px solid var(--surface-neutral-subtle);\n}\n\n.stepIndicator {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.stepCircle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  background-color: var(--surface-primary-medium);\n  border-radius: var(--spacing-1-5);\n}\n\n.stepNumber {\n  color: var(--text-neutral-white);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n}\n\n.stepTitle {\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-lg);\n  line-height: var(--type-title-md-line-height);\n  margin: 0;\n}\n\n/* Card Content */\n.cardContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  height: 100%;\n}\n\n.validationAlertToast {\n  position: absolute;\n  top: var(--spacing-3);\n  right: 0;\n  z-index: 1000;\n  width: 320px;\n  min-width: initial;\n  transform: initial;\n}\n\n.alert {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: var(--spacing-1) var(--spacing-1-5);\n  background-color: var(--info-card-background);\n  border: 1px solid var(--status-info);\n  border-radius: var(--radius-s);\n  margin-bottom: 0;\n  position: relative;\n}\n\n.alertIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--spacing-2-5);\n  height: var(--spacing-2-5);\n  color: var(--status-info);\n}\n\n.alertMessage {\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  flex: 1;\n}\n\n.alertCloseButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--spacing-2-5);\n  height: var(--spacing-2-5);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--text-neutral-stronger);\n  margin-left: auto;\n}\n\n.alertCloseButton:hover {\n  color: var(--text-neutral-dark);\n}\n\n/* Form Sections */\n.formSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n/* Step 2 Styles */\n.globalValueContainer {\n  display: flex;\n  gap: var(--spacing-2);\n  align-items: center;\n  margin-top: var(--spacing-1);\n}\n\n.applyToAllButton {\n  background-color: var(--surface-primary-medium);\n  color: var(--text-neutral-white);\n  border: none;\n  border-radius: var(--radius-s);\n  padding: var(--spacing-1) var(--spacing-2);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.applyToAllButton:hover {\n  background-color: var(--surface-primary-dark);\n}\n\n.beneficiariesHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-2);\n}\n\n.searchContainer {\n  max-width: 300px;\n}\n\n.searchField {\n  min-height: 40px;\n  padding-left: 12px;\n  background-color: var(--surface-neutral-white);\n  border: 1px solid var(--surface-neutral-subtle);\n  border-radius: var(--radius-s);\n}\n\n.selectAllContainer {\n  margin-bottom: var(--spacing-2);\n  padding-bottom: var(--spacing-1);\n  border-bottom: 1px solid var(--surface-neutral-subtle);\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  cursor: pointer;\n}\n\n.checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.checkboxText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n}\n\n.beneficiariesList {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.beneficiaryCard {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-2);\n  border: 1px solid var(--surface-neutral-subtle);\n  border-radius: var(--radius-s);\n  background-color: var(--surface-neutral-white);\n}\n\n.beneficiaryCard.disabled {\n  opacity: 0.6;\n  background-color: var(--surface-neutral-subtle);\n}\n\n.beneficiaryInfo {\n  flex: 1;\n}\n\n.beneficiaryDetails {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n  margin-left: var(--spacing-1);\n}\n\n.beneficiaryName {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n}\n\n.beneficiaryMeta {\n  display: flex;\n  gap: var(--spacing-2);\n}\n\n.position {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-stronger);\n}\n\n.registrationNumber {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-stronger);\n}\n\n.beneficiaryValue {\n  min-width: 120px;\n}\n\n.beneficiaryValueField {\n  min-height: 40px;\n  padding-left: 12px;\n  background-color: var(--surface-neutral-white);\n  border: 1px solid var(--surface-neutral-subtle);\n  border-radius: var(--radius-s);\n}\n\n/* Sidebar states */\n.completed {\n  color: var(--status-success) !important;\n}\n\n.completed .summaryStepCircle {\n  background-color: var(--status-success) !important;\n}\n\n/* Modal Styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-m);\n  padding: var(--spacing-4);\n  max-width: 480px;\n  width: 90%;\n  box-shadow: var(--shadow-modal);\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  margin-bottom: var(--spacing-3);\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.modalMessage {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-stronger);\n  line-height: var(--line-height-180);\n  margin-bottom: var(--spacing-4);\n}\n\n.modalActions {\n  display: flex;\n  gap: var(--spacing-2);\n  justify-content: flex-end;\n}\n\n.modalButton {\n  padding: var(--spacing-1-5) var(--spacing-3);\n  border-radius: var(--radius-s);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n  border: 1px solid var(--surface-neutral-subtle);\n  background-color: var(--surface-neutral-white);\n  color: var(--text-neutral-dark);\n}\n\n.modalButton:hover {\n  background-color: var(--surface-neutral-subtle);\n}\n\n.modalButton.primary {\n  background-color: var(--surface-primary-medium);\n  color: var(--text-neutral-white);\n  border-color: var(--surface-primary-medium);\n}\n\n.modalButton.primary:hover {\n  background-color: var(--surface-primary-dark);\n  border-color: var(--surface-primary-dark);\n}\n\n.successIcon {\n  color: var(--status-success);\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n}\n\n.errorIcon {\n  color: var(--status-error);\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n}\n\n/* Summary Sidebar Styles */\n.summaryStepIndicator {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  width: 100%;\n}\n\n.editButton {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: var(--spacing-0-5);\n  border-radius: var(--radius-s);\n  color: var(--text-neutral-stronger);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.editButton:hover {\n  background-color: var(--surface-neutral-subtle);\n  color: var(--text-neutral-dark);\n}\n\n.activeCardInfo {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n  width: 100%;\n}\n\n.activeCardData {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.activeLabel {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--type-label-sm-regular-font-weight, 400);\n  font-size: var(--type-label-sm-font-size, 12px);\n  line-height: 1.424;\n  width: 50%;\n  color: var(--text-neutral-stronger, #666666);\n}\n\n.activeValue {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--type-label-sm-font-weight, 600);\n  font-size: var(--type-label-sm-font-size, 12px);\n  line-height: 1.424;\n  width: 50%;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.stepSummary {\n  margin-top: var(--spacing-2);\n  display: flex;\n  flex-direction: column;\n}\n\n.summaryItem {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n  width: 100%;\n}\n\n.summaryLabel {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-stronger);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.summaryValue {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-dark);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.sectionTitle {\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--type-title-md-line-height);\n  margin: 0;\n}\n\n.sectionHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.radioGroup {\n  display: flex;\n  flex-direction: column;\n}\n\n.radioGroupDiscount {\n  display: flex;\n  gap: var(--spacing-3);\n  flex-direction: row;\n}\n\n.specificDayContainer {\n  margin-top: var(--spacing-1-5);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.specificDayField {\n  min-height: 48px;\n  padding-left: 12px;\n  background-color: var(--info-card-background);\n  border: 1px solid #cccccc;\n  border-radius: var(--radius-s);\n}\n\n.helpText {\n  color: var(--text-neutral-stronger);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-200);\n}\n\n.deductionOptions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n  margin-top: var(--spacing-1);\n}\n\n.deductionValueField {\n  min-height: 48px;\n  padding-left: 12px;\n  background-color: var(--info-card-background);\n  border: 1px solid #cccccc;\n  border-radius: var(--radius-s);\n}\n\n.radioItemParams {\n  background-color: transparent !important;\n  width: fit-content;\n  padding: 12px 0;\n}\n\n/* Switch Styles */\n.switchContainer {\n  position: relative;\n  display: inline-block;\n}\n\n.switchInput {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.switchLabel {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: var(--spacing-3);\n  cursor: pointer;\n}\n\n.switchSlider {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--surface-neutral-silver);\n  border-radius: var(--spacing-3);\n  transition: var(--transition-color);\n}\n\n.switchSlider:before {\n  position: absolute;\n  content: '';\n  height: var(--spacing-2);\n  width: var(--spacing-2);\n  left: var(--spacing-0-5);\n  bottom: var(--spacing-0-5);\n  background-color: var(--surface-neutral-white);\n  border-radius: 50%;\n  transition: var(--transition-transform);\n}\n\n.switchInput:checked + .switchLabel .switchSlider {\n  background-color: var(--surface-primary-medium);\n}\n\n.switchInput:checked + .switchLabel .switchSlider:before {\n  transform: translateX(var(--spacing-2));\n}\n\n/* Card Actions */\n.cardActions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n}\n\n.actionButton {\n  width: 100px;\n  height: 40px;\n  padding: var(--spacing-1) var(--spacing-1-5);\n  border-radius: var(--radius-s);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--type-label-md-line-height);\n  cursor: pointer;\n  transition: var(--transition-all);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid transparent;\n}\n\n.actionButton:first-child {\n  background-color: var(--surface-neutral-white);\n  color: var(--surface-primary-medium);\n  border-color: var(--surface-primary-medium);\n}\n\n.actionButton:last-child {\n  background-color: var(--surface-primary-medium);\n  color: var(--surface-neutral-white);\n  border-color: var(--surface-primary-medium);\n}\n\n/* Sidebar */\n.sidebarCard {\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-card);\n  height: fit-content;\n}\n\n.sidebarHeader {\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2);\n  border-bottom: 1px solid var(--surface-neutral-subtle);\n}\n\n.sidebarTitle {\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-lg);\n  line-height: var(--type-title-md-line-height);\n  margin: 0;\n}\n\n.divider {\n  height: 1px;\n  background-color: var(--stroke-neutral-soft);\n  margin: 0 10px;\n}\n\n.sidebarContent {\n  padding: var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.summaryStep {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.summaryStepCircle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  background-color: var(--surface-primary-medium);\n  border-radius: var(--spacing-1-5);\n}\n\n.summaryStepCircle.inactive {\n  background-color: transparent;\n  border: 1px solid var(--text-neutral-strong);\n}\n\n.summaryStepNumber {\n  color: var(--text-neutral-white);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n}\n\n.summaryStepCircle.inactive .summaryStepNumber {\n  color: var(--text-neutral-strong);\n}\n\n.summaryStepTitle {\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-lg);\n  line-height: var(--type-title-md-line-height);\n}\n\n.summaryStepTitle.inactive {\n  color: var(--text-neutral-strong);\n}\n\n.summaryDivider {\n  height: 1px;\n  background-color: var(--surface-neutral-subtle);\n  width: 100%;\n}\n\n.checkmarkIcon {\n  width: 14px;\n  height: 14px;\n  color: var(--text-neutral-white);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrapper": `uwNyXX`,
	"contentLayoutParameters": `BNzBPl`,
	"mainContent": `Yhb57M`,
	"mainCard": `A3qRV7`,
	"stepperHeader": `U7Z1kQ`,
	"stepIndicator": `XiDENF`,
	"stepCircle": `CezjAm`,
	"stepNumber": `uMQU25`,
	"stepTitle": `dcV4DD`,
	"cardContent": `xvUReK`,
	"validationAlertToast": `TKUjoz`,
	"alert": `pgXPXE`,
	"alertIcon": `NfkG1s`,
	"alertMessage": `hvl_kk`,
	"alertCloseButton": `RE5xLJ`,
	"formSection": `uSA7RN`,
	"globalValueContainer": `i8LGmH`,
	"applyToAllButton": `dJTfCF`,
	"beneficiariesHeader": `eNFS0H`,
	"searchContainer": `Nv4iaF`,
	"searchField": `fRef7J`,
	"selectAllContainer": `nKiDuH`,
	"checkboxLabel": `IPHEgW`,
	"checkbox": `rdlDG1`,
	"checkboxText": `HlfkXC`,
	"beneficiariesList": `OQfj9J`,
	"beneficiaryCard": `fjJURL`,
	"disabled": `cpRiq9`,
	"beneficiaryInfo": `OwkGZZ`,
	"beneficiaryDetails": `nHdU4I`,
	"beneficiaryName": `jIbx4b`,
	"beneficiaryMeta": `EpS6Ym`,
	"position": `xh1BMg`,
	"registrationNumber": `vFnLv2`,
	"beneficiaryValue": `izShMZ`,
	"beneficiaryValueField": `B6dDRQ`,
	"completed": `kNEqpv`,
	"summaryStepCircle": `ULMzdl`,
	"modalOverlay": `zCLgVZ`,
	"modal": `JYkHTG`,
	"modalHeader": `GGMrZF`,
	"modalTitle": `I60wgL`,
	"modalMessage": `GNirKT`,
	"modalActions": `UuF4U5`,
	"modalButton": `BekYjs`,
	"primary": `rS_uGb`,
	"successIcon": `Zp90lv`,
	"errorIcon": `E06q7J`,
	"summaryStepIndicator": `uz5_kh`,
	"editButton": `KPxBAP`,
	"activeCardInfo": `NVclKj`,
	"activeCardData": `epNcKW`,
	"activeLabel": `AcjaMv`,
	"activeValue": `Rj0pdC`,
	"stepSummary": `cWqMCB`,
	"summaryItem": `rA61FX`,
	"summaryLabel": `y3yMgp`,
	"summaryValue": `ZGix0J`,
	"sectionTitle": `wWzxkY`,
	"sectionHeader": `wZ6anQ`,
	"radioGroup": `P9eB6a`,
	"radioGroupDiscount": `uRBsN9`,
	"specificDayContainer": `u_lRu9`,
	"specificDayField": `JlFTPU`,
	"helpText": `gchZsx`,
	"deductionOptions": `k0X1dy`,
	"deductionValueField": `HT7UrA`,
	"radioItemParams": `_cd7hG`,
	"switchContainer": `K8nNg7`,
	"switchInput": `YXiqgo`,
	"switchLabel": `JX4Fez`,
	"switchSlider": `J4MBi7`,
	"cardActions": `Gr7p9N`,
	"actionButton": `PWAtXe`,
	"sidebarCard": `dubc8h`,
	"sidebarHeader": `eS5SDx`,
	"sidebarTitle": `LB7YLw`,
	"divider": `zEdnML`,
	"sidebarContent": `BCdX2O`,
	"summaryStep": `h6oiYQ`,
	"inactive": `bTBCdA`,
	"summaryStepNumber": `rRd0zY`,
	"summaryStepTitle": `SokGBa`,
	"summaryDivider": `z0jSrA`,
	"checkmarkIcon": `Rfb7ma`
};
module.exports = ___CSS_LOADER_EXPORT___;
